export class WLGoogleContact {
    public fullName: string = '';
    public email: string = '';
}
